import { RefObject, useEffect } from "react";

/**
 * This Hook conditionally adds an event listener to detect clicks outside
 * based on a boolean flag. It listens for outside clicks when the key matches.
 */
export default function useConditionalClickOutside(
  ref: RefObject<HTMLElement>,
  flag: boolean,
  onClickOutside: (event?: MouseEvent) => void,
  triggerRef?: RefObject<HTMLElement>,
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        (!triggerRef || !triggerRef.current?.contains(event.target as Node))
      ) {
        onClickOutside(event);
      }
    }

    if (flag) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, flag, onClickOutside]);
}
